import { $axios } from '~/utils/api'
const BASE_URL = 'https://api.mapbox.com/directions/v5/mapbox/'
const DRIVING = 'driving/'

const getDirections = (
  projectCenterLongitud: number,
  projectCenterLatitude: number,
  lotLongitude: number,
  lotLatitude: number,
  accessToken: string
): Promise<any> => {
  return $axios.$get(
    `${BASE_URL}${DRIVING}${projectCenterLongitud},${projectCenterLatitude};${lotLongitude},${lotLatitude}?geometries=geojson&access_token=${accessToken}`
  )
}

export { getDirections }
